module.exports = __webpack_public_path__ + "static/media/email.97bc89ac.svg";